(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    document.querySelectorAll('.siliane-header').forEach((header) => {
      const toggle = header.querySelector('[data-mobile-toggle]');
      const menu = header.querySelector('[data-mobile-menu]');
      if (!toggle || !menu) return;
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        if (open) menu.setAttribute('hidden', '');
        else menu.removeAttribute('hidden');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Défilement continu : le groupe d'annonces est dupliqué pour une boucle sans trou.
       Recalculé quand sa largeur change (promo saisonnière remplie après coup, compte à rebours). */
    const setupMarquee = (bar) => {
      const track = bar.querySelector('[data-announce-track]');
      const group = bar.querySelector('[data-announce-group]');
      if (!track || !group) return;
      const speed = parseFloat(bar.dataset.speed) || 45; // px par seconde
      let lastWidth = 0;

      const build = () => {
        const width = group.getBoundingClientRect().width;
        if (!width) return;
        const needed = Math.ceil(bar.clientWidth / width) + 1;
        const clones = track.querySelectorAll('[data-announce-clone]');
        if (Math.abs(width - lastWidth) < 1 && clones.length === needed) return;
        lastWidth = width;

        clones.forEach((c) => c.remove());
        for (let i = 0; i < needed; i++) {
          const clone = group.cloneNode(true);
          clone.removeAttribute('data-announce-group');
          clone.setAttribute('data-announce-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
          track.appendChild(clone);
        }
        track.style.setProperty('--group-w', width + 'px');
        track.style.setProperty('--marquee-duration', width / speed + 's');
      };

      build();
      new ResizeObserver(build).observe(group);
      window.addEventListener('resize', build);
    };

    /* Fondu : un message à la fois, relu à chaque tour (la promo peut apparaître après le chargement) */
    const setupFade = (bar) => {
      const interval = parseInt(bar.dataset.interval, 10) || 4000;
      const fade = parseInt(bar.dataset.fade, 10) || 400;
      bar.style.setProperty('--announce-fade', fade + 'ms');

      setInterval(() => {
        const items = [...bar.querySelectorAll('[data-announce-item]:not([hidden])')];
        if (items.length <= 1) return;
        const current = bar.querySelector('[data-announce-item].is-active') || items[0];
        const next = items[(items.indexOf(current) + 1) % items.length];

        current.classList.remove('is-active');
        current.setAttribute('aria-hidden', 'true');

        next.classList.add('is-active');
        next.setAttribute('aria-hidden', 'false');
      }, interval);
    };

    document.querySelectorAll('.siliane-announce').forEach((bar) => {
      if (bar.dataset.mode === 'fade') setupFade(bar);
      else setupMarquee(bar);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-pain-points"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.siliane-pain').forEach((section) => {
      const grid = section.querySelector('[data-pain-grid]');
      const counter = section.querySelector('[data-pain-counter]');
      const fill = section.querySelector('[data-pain-fill]');
      const hint = section.querySelector('[data-pain-hint]');
      const meter = section.querySelector('[data-pain-meter]');
      const bridge = section.querySelector('[data-pain-bridge]');
      const confettiLayer = section.querySelector('[data-pain-confetti]');
      if (!grid) return;

      const cards = Array.from(grid.querySelectorAll('[data-pain-card]'));
      const weightPerPain = parseInt(section.dataset.weight, 10) || 30;

      const hints = {
        0: 'Cochez ce qui vous concerne',
        1: 'Déjà un pattern — Siliane a été conçue pour ça',
        2: 'Vos symptômes pointent vers la même cause — on la traite',
        3: 'Diagnostic complet. Siliane est pensée exactement pour vous'
      };

      const emojiPool = ['✨', '🎉', '💫', '⭐', '🦷', '💥'];

      function animateCount(el, from, to, duration = 600) {
        const start = performance.now();
        function tick(now) {
          const p = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(from + (to - from) * eased);
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }

      function burstConfetti(fromEl) {
        if (!confettiLayer) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const rect = fromEl.getBoundingClientRect();
        const parentRect = section.getBoundingClientRect();
        const x = rect.left - parentRect.left + rect.width / 2;
        const y = rect.top - parentRect.top + rect.height / 2;
        for (let i = 0; i < 7; i++) {
          const s = document.createElement('span');
          s.textContent = emojiPool[Math.floor(Math.random() * emojiPool.length)];
          s.style.left = x + 'px';
          s.style.top = y + 'px';
          s.style.setProperty('--dx', (Math.random() * 200 - 100) + 'px');
          s.style.setProperty('--rot', (Math.random() * 720 - 360) + 'deg');
          confettiLayer.appendChild(s);
          setTimeout(() => s.remove(), 1200);
        }
      }

      let currentPct = 0;

      function update() {
        const checked = cards.filter((c) => c.getAttribute('aria-pressed') === 'true').length;
        const newPct = Math.min(checked * weightPerPain, 90);
        if (counter) animateCount(counter, currentPct, newPct);
        currentPct = newPct;
        if (fill) fill.style.width = newPct + '%';
        if (hint) hint.textContent = hints[checked] || hints[0];
        if (meter) meter.setAttribute('data-state', checked > 0 ? 'active' : 'idle');
        if (bridge) bridge.hidden = checked < 1;
      }

      cards.forEach((card) => {
        const toggle = () => {
          const next = card.getAttribute('aria-pressed') !== 'true';
          card.setAttribute('aria-pressed', next);
          if (next) burstConfetti(card);
          update();
        };
        card.addEventListener('click', toggle);
        card.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            toggle();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-social-notif"] && !Shopify.designMode) return;
  try {
    
  class SocialNotif extends HTMLElement {
    connectedCallback() {
      // Ne pas jouer dans l'éditeur de thème (aperçu figé)
      if (window.Shopify && window.Shopify.designMode) return;

      const dataEl = this.querySelector('[data-notifs]');
      let pool = [];
      try { pool = JSON.parse(dataEl.textContent) || []; } catch (e) { return; }
      pool = pool.filter(function (n) { return n && n.title; });
      if (!pool.length) return;

      this.cfg = {
        delayFirst: (parseFloat(this.dataset.delayFirst) || 5) * 1000,
        visible:    (parseFloat(this.dataset.visible)    || 2) * 1000,
        interval:   (parseFloat(this.dataset.interval)   || 8) * 1000,
        max:         parseInt(this.dataset.max, 10)      || 8,
        random:      this.dataset.random === 'true'
      };
      this.pool = pool;
      this.seq = 0;
      this.lastIdx = -1;

      // Compteur par session (limite le nombre d'affichages par visite)
      this.KEY = 'siliane_notif_shown';
      this.count = parseInt(sessionStorage.getItem(this.KEY) || '0', 10);

      this.card = this.querySelector('.siliane-social-notif__card');
      this.el = {
        thumb: this.querySelector('[data-thumb]'),
        img:   this.querySelector('[data-img]'),
        title: this.querySelector('[data-title]'),
        sub:   this.querySelector('[data-sub]'),
        time:  this.querySelector('[data-time]'),
        badge: this.querySelector('[data-badge]')
      };

      this._next = this._next.bind(this);
      this.timers = [];
      this.timers.push(setTimeout(this._next, this.cfg.delayFirst));
    }

    disconnectedCallback() {
      (this.timers || []).forEach(clearTimeout);
    }

    _pick() {
      if (!this.cfg.random) {
        const n = this.pool[this.seq % this.pool.length];
        this.seq++;
        return n;
      }
      // aléatoire sans répétition immédiate
      let i = Math.floor(Math.random() * this.pool.length);
      if (this.pool.length > 1 && i === this.lastIdx) i = (i + 1) % this.pool.length;
      this.lastIdx = i;
      return this.pool[i];
    }

    _render(n) {
      if (n.img) {
        this.el.img.src = n.img;
        this.el.thumb.hidden = false;
      } else {
        this.el.thumb.hidden = true;
      }
      this.el.title.textContent = n.title || '';
      if (n.sub) { this.el.sub.textContent = n.sub; this.el.sub.hidden = false; }
      else { this.el.sub.hidden = true; }
      this.el.time.textContent = n.time || '';
      this.el.badge.hidden = !n.badge;
    }

    _next() {
      if (this.count >= this.cfg.max) return;
      // Onglet en arrière-plan : on repousse sans consommer
      if (document.hidden) { this.timers.push(setTimeout(this._next, 1500)); return; }

      this._render(this._pick());
      this.classList.add('is-visible');
      this.count++;
      try { sessionStorage.setItem(this.KEY, String(this.count)); } catch (e) {}

      this.timers.push(setTimeout(() => this.classList.remove('is-visible'), this.cfg.visible));
      this.timers.push(setTimeout(this._next, this.cfg.visible + this.cfg.interval));
    }
  }
  if (!customElements.get('social-notif')) {
    customElements.define('social-notif', SocialNotif);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-social-proof"] && !Shopify.designMode) return;
  try {
    
  class TestimonialCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => this.scroll(-1));
      this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.scroll(1));
    }
    scroll(dir) {
      if (!this.track) return;
      const card = this.track.querySelector('.siliane-sp__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).gap || 16);
      const step = card.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: step * dir, behavior: 'smooth' });
    }
  }
  if (!customElements.get('testimonial-carousel')) {
    customElements.define('testimonial-carousel', TestimonialCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      const triggerSelector = this.dataset.trigger || '.siliane-hero-product__content';
      const trigger = document.querySelector(triggerSelector);
      this.removeAttribute('hidden');

      const applyPadding = () => {
        // Libère l'espace en bas du body pour que le footer reste visible
        const h = this.offsetHeight;
        if (h > 0) document.body.style.paddingBottom = h + 'px';
      };
      const clearPadding = () => { document.body.style.paddingBottom = ''; };

      const show = () => {
        this.setAttribute('data-active', 'true');
        // Attend la fin de la transition pour mesurer la hauteur réelle
        requestAnimationFrame(() => requestAnimationFrame(applyPadding));
      };
      const hide = () => {
        this.removeAttribute('data-active');
        clearPadding();
      };

      // Re-mesure si la fenêtre est resize (orientation, clavier mobile, etc.)
      window.addEventListener('resize', () => {
        if (this.getAttribute('data-active') === 'true') applyPadding();
      }, { passive: true });

      if (trigger && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) hide();
            else if (entry.boundingClientRect.top < 0) show();
            else hide();
          });
        }, { threshold: 0, rootMargin: '0px 0px -60% 0px' });
        io.observe(trigger);
      } else {
        // fallback: show after 500px scroll
        const onScroll = () => { window.scrollY > 500 ? show() : hide(); };
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    }
  }
  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);

  } catch(e) { console.error(e); }
})();
})();
